module.exports = __webpack_public_path__ + "img/React.358dedab.webp";